<div class="flex">
  <mat-radio-button
    (change)="radioChange($event)"
    [checked]="+payload.properties.value.value === 1"
    [name]="parentId + '_' + payload.properties.group.value"
    ngDefaultControl
    >{{ payload.properties.text.value }}</mat-radio-button
  >
  <fb-amendment-field-indicator />
</div>
